<div class="page-not-found-container">
  <p>The page you're looking for isn't here.</p>
  <a href="#" (click)="redirect(); $event.preventDefault()">Go back to AC Status List</a>
</div>